import React from 'react';
import { DateField, SaveButton, Toolbar, TextField
} from 'react-admin';
import { CancelOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';

export default function EntityToolbar(props) {
  const history = useHistory();
  return (
  <Toolbar {...props}>
    <SaveButton />
    <Button label="Cancel" variant="contained" color="default" onClick={() => history.goBack()} startIcon={<CancelOutlined />} style={{marginLeft: '20px', paddingLeft: '16px', paddingRight: '16px', paddingTop: '6px', paddingBottom: '6px'}}>Cancel</Button>
    <div style={{display: 'flex', flexDirection: 'column', align: 'left', alignItems: 'left', gap: '5px', width: '100%'}}>
      <div>
        <span style={{ paddingLeft: '20px', fontSize: 'smaller' }}>Update date</span><DateField source="updated_at" label="Update date" showTime style={{ paddingLeft: '5px' }} />
      </div>
      <div>
        <span style={{ paddingLeft: '20px', fontSize: 'smaller' }}>Updated by </span><TextField source="updated_name" label="Updated by" style={{ paddingLeft: '5px' }} />
      </div>
    </div>
  </Toolbar>
  )
};